module.exports = __webpack_public_path__ + "static/the-fellowship-of-the-ring-78df5260dc0c2fa158dd0f8cb48355bc.jpg";